import * as Sentry from "@sentry/browser";

const RAILS_ENV = typeof process !== "undefined" ? process.env?.RAILS_ENV : undefined;
const SHAKAPACKER_PUBLIC_SENTRY_DSN =
  typeof process !== "undefined" ? process.env?.SHAKAPACKER_PUBLIC_SENTRY_DSN : undefined;

window.Sentry = Sentry;

if (RAILS_ENV === "staging" || RAILS_ENV === "production") {
  Sentry.init({
    dsn: SHAKAPACKER_PUBLIC_SENTRY_DSN,
    environment: RAILS_ENV,
    ignoreErrors: [
      // Benign browser error from third-party ResizeObserver usage (Chart.js,
      // Algolia autocomplete) that we can't fix at the source.
      "ResizeObserver loop completed with undelivered notifications",
      "ResizeObserver loop limit exceeded",
      // Transient Algolia connectivity failures from the user's browser.
      "Unreachable hosts",
    ],
    denyUrls: [
      // Safari internal autofill/extensions code — not our bugs
      /webkit-masked-url:\/\/hidden\//,
    ],
  });

  const email = window.Scout?.currentUserEmail;

  if (email) {
    Sentry.getCurrentScope().setUser({ email });
  }
}
